import { render, staticRenderFns } from "./FornecedorEditar.vue?vue&type=template&id=f0922f2c&"
import script from "./FornecedorEditar.vue?vue&type=script&lang=js&"
export * from "./FornecedorEditar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports